/**
 * Reads and parses the HandTalk config from the injected script tag.
 * Returns the parsed object or null if the tag is absent.
 */
export const readHandTalkScript = () => {
    const scriptTag = document.getElementById('handtalk_data');

    if (!scriptTag) {
        console.warn('HandTalk data script not found!');
        return null;
    }

    return JSON.parse(scriptTag.textContent);
};

/**
 * Reads and parses the general application data from the injected script tag.
 * Returns the parsed object or null if the tag is absent or malformed.
 */
export const readGeneralApplicationDataScript = () => {
    try {
        const scriptTag = document.querySelector('#general_application_data');

        if (!scriptTag) {
            console.warn('Application data script tag not found!');
            return null;
        }

        return JSON.parse(scriptTag.textContent);
    } catch (e) {
        console.error('Uncaught error while reading general application data:', e);
        return null;
    }
};

/**
 * Resolves the backend base URL for media assets.
 * Ensures the path always ends with "media/".
 */
export const resolveServerUrl = () => {
    const base = process.env.NODE_ENV === 'development'
        ? process.env.PREACT_APP_BACKEND_URL ?? ''
        : '';

    return base.endsWith('/') ? `${base}media/` : `${base}/media/`;
};
